import { render, staticRenderFns } from "./TitleSlot.vue?vue&type=template&id=3b7a567d&scoped=true&"
import script from "./TitleSlot.vue?vue&type=script&lang=js&"
export * from "./TitleSlot.vue?vue&type=script&lang=js&"
import style0 from "./TitleSlot.vue?vue&type=style&index=0&id=3b7a567d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a567d",
  null
  
)

export default component.exports